/**
 * Internationalization Configuration
 * Supports English and French translations
 */

import { createI18n } from 'vue-i18n';

const messages = {
  en: {
    home: "Home",
    publicSector: "Public Sector",
    privateSector: "Private Sector",
    noaccounts: "No Accounts",
    about: "Info",
    saerch: "Search",
    contactUs: "Contact Us",
    emptysearchResults: "No Results Found.",
    reportIncident: "Report Incident",
    addStructure: "Add Structure",
    language: "EN",
    loading: "Loading...",
    officialAccounts: "Official Accounts Directory",
    nationalAgency: "NATIONAL AGENCY FOR INFORMATION AND COMMUNICATION TECHNOLOGIES",
    directory: "DIRECTORY OF THE OFFICIAL ACCOUNTS OF PUBLIC AND PRIVATE STRUCTURES",
    auth: "Official Directory of Social Media Accounts for Public and Private Structures, State Officials, and Public Personalities",
    head: "Head of Structure",
    otherspersonnels: "Key Personnels",
    regionals: "Regional Delegations",
    more: "read more",
    readMore: "read more",
    filterByCategory: "Filter by Category",
    clearFilter: "Clear",
    allCategories: "All",
    showing: "Showing",
    bossContactSection: "Connect and Follow",
    fillFormBelow: "Fill out the form below to report any social media impersonated accounts.",
    name: "Full Names",
    enterName: "Please enter your full names here",
    phone: "Phone Number",
    enterPhone: "Please enter your phone number",
    email: "Email",
    enterEmail: "Please enter a valid email account",
    description: "Description",
    evidences: "Evidences",
    maxFiles: "Evidence should not exceed 5",
    browseFiles: "Browse Files",
    dragDropFiles: "Drag and Drop Files",
    addMoreFiles: "Add More Evidence",
    submit: "Submit",
    submitting: "Submitting",
    construct: "In Maintenance",
    constructMessage: "We're currently working on this section. Please check back soon!",
    fetchError: "Could not load data. Please try again later.",
    messageContact: "Send Us a Message",
    umsg: "Your Message",
    location: "Location",
    actuallocation: "Chinese Embassy Street (Bastos)",
    townnation: "Yaounde",
    follow: "Follow Us on",
    instructform: "Fill out the form or reach out through our other channels",
    contactinfo: "Contact Information",
    emergency: "Emergency",
    intouch: "Get In Touch with Us",
    intouchinfo: "We're here to help and answer any questions you might have",
    success: "Your Message has been successful submitted. Our Staff will reach out to you soon!",
    footerbanner: "Get along with us on social networks:",
    apptitle: "CHECK-APP",
    appdes: "CHECK-APP is a solution that intends to reduce the risk of cyber crime, especially on social media by regrouping the official social media accounts of public and private renowned structures",
    otherRrc: "OTHER RESOURCES",
    usefullinks: "USEFUL LINKS",
    contacts: "CONTACTS",
    nomissionsTtile: "Coming Soon",
    nomissiondescription: "We are currently developing our mission portfolio with great care and precision. Our team is working diligently to curate and showcase meaningful missions that align with our strategic objectives",
    nomissionnote: "Please check back soon for updates, or explore other areas of our platform.",
    noMissiondes: "No description yet for this mission",
    missions: "Missions",
    popularMinistries: "Popular Ministries",
    noPrivateSectorsAvailable: "No private sectors available at this time",
    noContactAvailable: "No Account",
    noResultsTitle: "No Title for this Result",
    noDescriptionAvailable: "More details coming—check back later!",
    noDataAvailable: "No Data Available",
    noPhoneNumber: "No Phone Numbers Available",
    noLocation: "No Location Details",
    Main: "Main Contact",
    getDirections: "Get Google Map Direction",
    noInformationAvailable: "Not available for Now",
    noLocationAvailable: "No Location Details Available",
    clearHistory: "Clear History",
    noRegionalsTitle: "No Regional Delegations Available",
    noRegionalsDescription: "Regional delegation information will be added soon.",
    searchPlaceholderShort: "Enter any key word",
    previous: "Previous",
    next: "Next",
    embassies: "Diplomatic Missions",
    subStructures: "Defense and Security Forces",
    subStructuresOf: "Sub-Structures of",
    noSubStructures: "No sub-structures available",
    viewSubStructure: "View",
    embassiesAndConsulates: "Embassies and Consulates",
    servicesOffered: "Services Offered",
    searchEmbassies: "Search for Cameroon Embassies",
    common: {
      previous: 'Previous',
      next: 'Next',
      errorLoading: 'Failed to load data. Please try again later.',
    },
    personalities: {
      title: 'Public Personalities',
      subtitle: 'Explore a directory of notable public figures and their official social media presence.',
      searchLabel: 'Search Personalities',
      searchPlaceholder: 'Search by name or title...',
      showLabel: 'Show',
      perPage: '{count} per page',
      noSocials: 'No social media links',
      noResultsTitle: 'No Personalities Found',
      noResultsSubtitle: 'Your search for "{query}" did not match any records.'
    },
    search: {
      placeholder: "Search for an official, organization, number...",
      verifying: "Verifying...",
      searching: "Searching...",
      recentSearches: "Recent searches",
      popularSearches: "Popular Searches",
      searchHistory: "Search History",
      noResults: "No results found for \"{searchTerm}\"",
      resultsCount: "About {count} results for \"{term}\"",
      trySearching: "Try searching for ministries, officials, embassies...",
      searchTips: "Search Tips",
      tip1: "Use keywords like ministry names or abbreviations (MINPOSTEL, MINAT)",
      tip2: "Search for officials by name or title",
      tip3: "Find embassy information by country name",
      viewAll: "View all results",
      topResults: "Top Results",
      maliciousWarningTitle: "Warning: Potentially Malicious Resource",
      maliciousWarningBody: "The resource you searched for, <strong class=\"text-red-800 break-all\">\"{resourceName}\"</strong>, has been flagged. This resource, claiming to be from the <strong class=\"text-red-800\">{institution}</strong>, has been reported as <strong class=\"text-red-800\">{authenticity}</strong> and may be associated with fraudulent activities or misinformation.",
      maliciousWarningAdvice: "Please exercise extreme caution. Engaging with this resource may put you at risk.",
      understandAndClose: "I Understand, Close This Warning",
      askChatbot: "Ask our assistant",
      description: "Details",
      reportedTimes: "Reported {count} times by our users",
      verifiedTitle: "Resource Verified",
      verifiedBody: "The resource you searched for, <strong class=\"text-green-800 break-all\">\"{resourceName}\"</strong>, has been verified. This resource from the <strong class=\"text-green-800\">{institution}</strong> is confirmed as <strong class=\"text-green-800\">{authenticity}</strong>.",
      verifiedAdvice: "You can use this resource with confidence.",
      continue: "Continue",
      verificationNeededTitle: "Verification Needed",
      verificationNeededBody: "We could not find any information for the search term: <strong class=\"text-yellow-800 break-all\">\"{searchTerm}\"</strong>.",
      verificationNeededAdvice: "This means we cannot certify whether this resource is authentic or fake. Please be careful when interacting with unverified phone numbers or links.",
      understandAndBeCareful: "I Understand and Will Be Careful",
    },
    searchResults: {
      home: "Home",
      placeholder: "Search ministries, officials...",
      didYouMean: "Did you mean:",
      matchedPersonnel: "Matched Personnel",
      contactsAndSocial: "Contacts & Social Media",
      missionsOf: "Missions",
      moreMissions: "+ {count} more missions",
      regionalsOf: "Regional Delegations",
      moreRegionals: "+ {count} more regional delegations",
      personnelOf: "Key Personnels",
      servicesOf: "Services Offered",
      morePersonnel: "+ {count} more personnel",
      andMore: "more",
      noResults: {
        title: "No results found",
        subtitle: "Your search for \"{searchTerm}\" did not match any entries."
      },
      pagination: { previous: "Previous", next: "Next" },
      sidebar: {
        noMap: "No map or photo available",
        getDirections: "Get Directions",
        quickLinks: {
          title: "Quick Links",
          govPortal: "Government Portal",
          gazette: "Official Gazette",
          assembly: "National Assembly"
        }
      },
      initial: {
        title: "Search for ministries or officials",
        subtitle: "Enter a name or keyword in the search bar above."
      },
      error: {
        generic: "An error occurred during search. Please try again.",
        navigation: "Failed to navigate to the selected result. Please try again."
      },
      header: {
        showingResults: "Showing {total} results for {intentText} {entity}",
        noResults: "No results found for \"{searchTerm}\"",
        peopleMatching: "people matching",
        locationsFor: "locations for",
        contactsFor: "contacts for"
      }
    },
    dashboard: {
      noAccountFor: "No {platform} account",
      aria: { collapse: "Collapse menu", expand: "Expand menu" },
      contactCard: { title: "Contact" },
      error: {
        title: "An error occurred",
        suggestion: "Please check your Internet connection and try again. If the problem persists, the service may be temporarily unavailable.",
        retry: "Retry",
        invalidStructure: "No valid structure ID was provided. Unable to load data.",
        fetchingData: "An error occurred while fetching structure data."
      },
      bossView: {
        biography: "Biography",
        noContactForPlatform: "No {platform} account available"
      },
      embassiesAndConsulates: "Embassies and Consulates"
    },
    embassy: {
      cameroonEmbassiesAbroad: "Cameroon Embassies Abroad",
      foreignEmbassiesInCameroon: "Foreign Embassies in Cameroon",
      searchPlaceholder: "Search by country or embassy name...",
      noEmbassiesFoundTitle: "No Embassies Found",
      searchagain: "Reset Search",
      viewdetails: "More Details",
      subtitle: "Find Diplomatic Missions and their Contact Information",
      noEmbassiesFoundMessage: "Embassy information for this category is being updated. Please check back later.",
      embassyOf: "Embassy of {country}",
      ambassador: "Ambassador",
      services: "Services",
      biography: "Biography",
      connectAndFollow: "Connect and Follow",
      noServicesTitle: "Services Coming Soon",
      noServicesDescription: "We are currently compiling the list of services offered by this embassy.",
      noServicesNote: "Please check back soon for updates.",
      error: {
        invalidEmbassy: "No valid embassy was specified. Unable to load data.",
        embassyNotFound: "The requested embassy could not be found in our directory.",
        fetchingData: "An error occurred while fetching embassy details. Please try again."
      }
    },
    seeAllResults: "See all results for",
    biography: "Biography",
    searching: "Searching...",
    missionNumber: "Mission {number}",
    serviceNumber: "Service {number}",
    noEmailAddress: "No Email Address",
    optional: "Optional",
    submiting: "Submitting...",
    no_results_title: "No Results Found",
    no_results_message: "We could not find any matches for your search.",
    page_indicator: "Page {current} of {total}",
    search_placeholder: "Search...",
    error: {
      title: "An error occurred",
      suggestion: "Please check your Internet connection and try again. If the problem persists, the service may be temporarily unavailable.",
      retry: "Retry",
      invalidStructure: "No valid structure ID was provided. Unable to load data.",
      fetchingData: "An error occurred while fetching data.",
      networkError: "Network error. Please check your connection and try again.",
      serverError: "The server encountered an error. Please try again later.",
      submitFailed: "Failed to submit your request. Please try again.",
      validationFailed: "Please correct the errors in the form before submitting.",
    },
    validation: {
      nameRequired: "Full name is required",
      emailRequired: "Email address is required",
      emailInvalid: "Please enter a valid email address",
      phoneRequired: "Phone number is required",
      phoneInvalid: "Please enter a valid phone number",
      descriptionRequired: "Description is required",
      captchaRequired: "Please complete the CAPTCHA verification",
      captchaExpired: "CAPTCHA verification expired. Please try again.",
      captchaFailed: "CAPTCHA verification failed. Please try again.",
    },
    bilingualSearchHint: "Showing results found in {lang}. You searched in {searchLang}.",
    langNameEn: "English",
    langNameFr: "French",
    switchToResultsLang: "Switch language to {lang}",
    chatbot: {
      title: "Directory Assistant",
      subtitle: "Ask me anything about structures, officials, or embassies",
      placeholder: "Ask a question...",
      placeholderExamples: "e.g., 'Does MINPOSTEL have a Facebook page?'",
      send: "Send",
      typing: "Typing...",
      thinking: "Thinking...",
      error: "Sorry, I couldn't process your request. Please try again.",
      networkError: "Connection error. Please check your internet and try again.",
      welcome: "Hello! I'm your directory assistant. I can help you find information about:",
      welcomeItems: [
        "Government ministries and their social media accounts",
        "Officials and their contact information",
        "Embassies and diplomatic missions",
        "Verify if an account or phone number is official"
      ],
      exampleQuestions: "Try asking:",
      examples: [
        "Does the Minister of MINAT have a Facebook account?",
        "What is CAMTEL's official Twitter?",
        "Contact information for the US Embassy",
        "Is this phone number official: +237 6XX XXX XXX?"
      ],
      minimize: "Minimize",
      close: "Close",
      openChat: "Chat with Assistant",
      clearChat: "Clear conversation",
      poweredBy: "Powered by CHECK-APP AI",
      seeAllResults: "See all results for",
    },

    // ── Sidebar Menu ──────────────────────────────────────────────────────────
    services: "Services",
    legalConformity: "Legal Conformity",

    // ── Legal Conformity ──────────────────────────────────────────────────────
    physicallyVerified: "Physically Verified — this structure has been confirmed to physically exist",
    requirementsMet: "requirements met",
    noConformityData: "No Conformity Data",
    noConformityDesc: "No legal conformity information is available for this structure yet.",
    physical: "Physical",
    conformityScore: "Conformity Score",
    compliant: "Compliant",
    notCompliant: "Not Compliant",
    physicalConformityName: "Physical Conformity",
    physicalConformityDesc: "The structure physically exists and has been verified on-site.",

    // ── Registration Portal ───────────────────────────────────────────────────
    registerPortal: "Structure Registration Portal",
    registerTitle: "Create Your Account",
    registerSubtitle: "Register your structure on Check-App",
    loginPortal: "Sign In to Your Account",
    firstName: "First Name",
    lastName: "Last Name",
    password: "Password",
    confirmPassword: "Confirm Password",
    createAccount: "Create Account",
    alreadyHaveAccount: "Already have an account?",
    noAccount: "Don't have an account?",
    signIn: "Sign In",
    verifyEmailTitle: "Verify Your Email",
    verifyEmailMsg: "We sent a verification link to your email. Please click it to activate your account.",
    emailVerifiedTitle: "Email Verified!",
    emailVerifiedMsg: "Your account is now active. You can log in.",
    myStructures: "My Structures",
    newStructure: "Register New Structure",
    structureInfo: "Structure Information",
    contactInfo: "Contact Information",
    socialMedia: "Social Media",
    servicesSection: "Services",
    personnelSection: "Key Personnel",
    delegationsSection: "Regional Delegations",
    conformitySection: "Legal Conformity",
    documentSection: "Declaration Document",
    saveAsDraft: "Save as Draft",
    submitForReview: "Submit for Review",
    downloadPdf: "Download PDF Form",
    downloadDocx: "Download Word Form",
    uploadSigned: "Upload Signed Document",
    uploadSignedHint: "Print, sign, stamp the form and upload the scanned version (PDF or image)",
    pendingReview: "Pending Review",
    approved: "Approved",
    rejected: "Rejected",
    draft: "Draft",
    structureName: "Structure Name",
    structureNameEn: "Name (English)",
    structureNameFr: "Name (French)",
    abbreviationEn: "Abbreviation (EN)",
    abbreviationFr: "Abbreviation (FR)",
    descriptionEn: "Description (English)",
    descriptionFr: "Description (French)",
    stateOrder: "State Order / Sector",
    isHeadOfStructure: "Head of Structure",
    addService: "Add Service",
    addPersonnel: "Add Personnel",
    addDelegation: "Add Regional Delegation",
    region: "Region",
    selectConformityCategories: "Select your conformity categories",
    tickRequirements: "Tick the requirements you fulfill",
    conformityHidden: "Conformity categories will be assigned by the administration.",
    reviewNotes: "Review Notes",
    incompleteWarning: "Please fill in at least the structure name, phone, email and state order before submitting.",
    submittedMsg: "Your structure has been submitted for review. You will be notified by email of the decision.",
    adminPortal: "Admin Portal",
    adminLogin: "Administrator Login",
    enterOtp: "Enter your one-time code",
    otpSentMsg: "A verification code was sent to your email and WhatsApp.",
    verifyCode: "Verify Code",
    pendingStructures: "Pending Structures",
    approveStructure: "Approve",
    rejectStructure: "Reject",
    enterRejectionNotes: "Enter rejection notes for the applicant",
  },

  fr: {
    home: "Accueil",
    publicSector: "Secteur Public",
    privateSector: "Secteur Privé",
    noaccounts: "Aucun Compte",
    about: "À Propos",
    saerch: "Rechercher",
    contactUs: "Nous Contacter",
    emptysearchResults: "Aucun Résultat Trouvé.",
    reportIncident: "Signaler un Incident",
    addStructure: "Ajouter une Structure",
    language: "FR",
    loading: "Chargement...",
    officialAccounts: "Répertoire des Comptes Officiels",
    nationalAgency: "AGENCE NATIONALE DES TECHNOLOGIES DE L'INFORMATION ET DE LA COMMUNICATION",
    directory: "RÉPERTOIRE DES COMPTES OFFICIELS DES STRUCTURES PUBLIQUES ET PRIVÉES",
    auth: "Répertoire Officiel des Comptes de Médias Sociaux des Structures Publiques et Privées, des Hauts Fonctionnaires et des Personnalités Publiques",
    head: "Chef de Structure",
    otherspersonnels: "Personnel Clé",
    regionals: "Délégations Régionales",
    more: "lire plus",
    readMore: "lire plus",
    filterByCategory: "Filtrer par catégorie",
    clearFilter: "Effacer",
    allCategories: "Tous",
    showing: "Affichage",
    bossContactSection: "Connectez-vous et Suivez",
    fillFormBelow: "Remplissez le formulaire ci-dessous pour signaler tout compte de médias sociaux usurpé.",
    name: "Noms Complets",
    enterName: "Veuillez entrer vos noms complets ici",
    phone: "Numéro de Téléphone",
    enterPhone: "Veuillez entrer votre numéro de téléphone",
    email: "Email",
    enterEmail: "Veuillez entrer une adresse email valide",
    description: "Description",
    evidences: "Preuves",
    maxFiles: "Les preuves ne doivent pas dépasser 5",
    browseFiles: "Parcourir les Fichiers",
    dragDropFiles: "Glisser-Déposer les Fichiers",
    addMoreFiles: "Ajouter Plus de Preuves",
    submit: "Soumettre",
    submitting: "Soumission en cours",
    construct: "En Maintenance",
    constructMessage: "Nous travaillons actuellement sur cette section. Veuillez revenir bientôt !",
    fetchError: "Impossible de charger les données. Veuillez réessayer plus tard.",
    messageContact: "Envoyez-nous un Message",
    umsg: "Votre Message",
    location: "Localisation",
    actuallocation: "Rue de l'Ambassade de Chine (Bastos)",
    townnation: "Yaoundé",
    follow: "Suivez-nous sur",
    instructform: "Remplissez le formulaire ou contactez-nous par nos autres canaux",
    contactinfo: "Informations de Contact",
    emergency: "Urgence",
    intouch: "Entrez en Contact avec Nous",
    intouchinfo: "Nous sommes là pour vous aider et répondre à toutes vos questions",
    success: "Votre message a été soumis avec succès. Notre équipe vous contactera bientôt !",
    footerbanner: "Rejoignez-nous sur les réseaux sociaux :",
    apptitle: "CHECK-APP",
    appdes: "CHECK-APP est une solution qui vise à réduire le risque de cybercriminalité, notamment sur les réseaux sociaux, en regroupant les comptes officiels des structures publiques et privées renommées",
    otherRrc: "AUTRES RESSOURCES",
    usefullinks: "LIENS UTILES",
    contacts: "CONTACTS",
    nomissionsTtile: "Bientôt Disponible",
    nomissiondescription: "Nous développons actuellement notre portefeuille de missions avec beaucoup de soin et de précision. Notre équipe travaille avec diligence pour créer et présenter des missions significatives",
    nomissionnote: "Veuillez revenir bientôt pour les mises à jour, ou explorez d'autres sections de notre plateforme.",
    noMissiondes: "Pas encore de description pour cette mission",
    missions: "Missions",
    popularMinistries: "Ministères Populaires",
    noPrivateSectorsAvailable: "Aucun secteur privé disponible pour le moment",
    noContactAvailable: "Aucun Compte",
    noResultsTitle: "Aucun Titre pour ce Résultat",
    noDescriptionAvailable: "Plus de détails à venir—revenez plus tard !",
    noDataAvailable: "Aucune Donnée Disponible",
    noPhoneNumber: "Aucun Numéro de Téléphone Disponible",
    noLocation: "Aucun Détail de Localisation",
    Main: "Contact Principal",
    getDirections: "Obtenir l'Itinéraire Google Map",
    noInformationAvailable: "Non disponible pour le moment",
    noLocationAvailable: "Aucun Détail de Localisation Disponible",
    clearHistory: "Effacer l'Historique",
    noRegionalsTitle: "Aucune Délégation Régionale Disponible",
    noRegionalsDescription: "Les informations sur les délégations régionales seront bientôt ajoutées.",
    searchPlaceholderShort: "Entrez un mot clé",
    previous: "Précédent",
    next: "Suivant",
    embassies: "Missions Diplomatiques",
    subStructures: "Forces de Défense et de Sécurité",
    subStructuresOf: "Sous-Structures de",
    noSubStructures: "Aucune sous-structure disponible",
    viewSubStructure: "Voir",
    embassiesAndConsulates: "Ambassades et Consulats",
    servicesOffered: "Services Offerts",
    searchEmbassies: "Rechercher les Ambassades du Cameroun",
    common: {
      previous: 'Précédent',
      next: 'Suivant',
      errorLoading: 'Échec du chargement des données. Veuillez réessayer plus tard.',
    },
    personalities: {
      title: 'Personnalités Publiques',
      subtitle: 'Explorez un répertoire de personnalités publiques et leur présence officielle sur les réseaux sociaux.',
      searchLabel: 'Rechercher des Personnalités',
      searchPlaceholder: 'Rechercher par nom ou titre...',
      showLabel: 'Afficher',
      perPage: '{count} par page',
      noSocials: 'Aucun lien de réseau social',
      noResultsTitle: 'Aucune Personnalité Trouvée',
      noResultsSubtitle: 'Votre recherche pour "{query}" n\'a retourné aucun résultat.'
    },
    search: {
      placeholder: "Rechercher un officiel, une organisation, un numéro...",
      verifying: "Vérification...",
      searching: "Recherche...",
      recentSearches: "Recherches récentes",
      popularSearches: "Recherches populaires",
      searchHistory: "Historique de recherche",
      resultsCount: "Environ {count} résultats pour \"{term}\"",
      noResults: "Aucun résultat trouvé pour \"{searchTerm}\"",
      trySearching: "Essayez de rechercher des ministères, officiels, ambassades...",
      searchTips: "Conseils de recherche",
      tip1: "Utilisez des mots-clés comme les noms de ministères ou abréviations (MINPOSTEL, MINAT)",
      tip2: "Recherchez des officiels par nom ou titre",
      tip3: "Trouvez des informations sur les ambassades par nom de pays",
      viewAll: "Voir tous les résultats",
      topResults: "Meilleurs résultats",
      maliciousWarningTitle: "Avertissement : Ressource potentiellement malveillante",
      maliciousWarningBody: "La ressource que vous avez recherchée, <strong class=\"text-red-800 break-all\">\"{resourceName}\"</strong>, a été signalée. Cette ressource, prétendant provenir de <strong class=\"text-red-800\">{institution}</strong>, a été rapportée comme <strong class=\"text-red-800\">{authenticity}</strong> et peut être associée à des activités frauduleuses ou de la désinformation.",
      maliciousWarningAdvice: "Veuillez faire preuve d'une extrême prudence. L'utilisation de cette ressource peut vous mettre en danger.",
      understandAndClose: "Je comprends, fermer cet avertissement",
      askChatbot: "Demandez à notre assistant",
      description: "Détails",
      reportedTimes: "Signalé {count} fois par nos utilisateurs",
      verifiedTitle: "Ressource vérifiée",
      verifiedBody: "La ressource que vous avez recherchée, <strong class=\"text-green-800 break-all\">\"{resourceName}\"</strong>, a été vérifiée. Cette ressource de <strong class=\"text-green-800\">{institution}</strong> est confirmée comme <strong class=\"text-green-800\">{authenticity}</strong>.",
      verifiedAdvice: "Vous pouvez utiliser cette ressource en toute confiance.",
      continue: "Continuer",
      verificationNeededTitle: "Vérification nécessaire",
      verificationNeededBody: "Nous n'avons trouvé aucune information pour le terme de recherche : <strong class=\"text-yellow-800 break-all\">\"{searchTerm}\"</strong>.",
      verificationNeededAdvice: "Cela signifie que nous ne pouvons pas certifier si cette ressource est authentique ou fausse. Soyez prudent lorsque vous interagissez avec des numéros de téléphone ou des liens non vérifiés.",
      understandAndBeCareful: "Je comprends et je serai prudent",
    },
    searchResults: {
      home: "Accueil",
      placeholder: "Rechercher ministères, officiels...",
      didYouMean: "Vouliez-vous dire :",
      matchedPersonnel: "Personnel correspondant",
      contactsAndSocial: "Contacts et Réseaux Sociaux",
      missionsOf: "Missions",
      moreMissions: "+ {count} autres missions",
      regionalsOf: "Délégations Régionales",
      moreRegionals: "+ {count} autres délégations régionales",
      personnelOf: "Personnel Clé",
      servicesOf: "Services Offerts",
      morePersonnel: "+ {count} autres personnels",
      andMore: "plus",
      noResults: {
        title: "Aucun résultat trouvé",
        subtitle: "Votre recherche pour \"{searchTerm}\" n'a retourné aucun résultat."
      },
      pagination: { previous: "Précédent", next: "Suivant" },
      sidebar: {
        noMap: "Aucune carte ou photo disponible",
        getDirections: "Obtenir l'itinéraire",
        quickLinks: {
          title: "Liens Rapides",
          govPortal: "Portail du Gouvernement",
          gazette: "Journal Officiel",
          assembly: "Assemblée Nationale"
        }
      },
      initial: {
        title: "Rechercher des ministères ou des officiels",
        subtitle: "Entrez un nom ou un mot-clé dans la barre de recherche ci-dessus."
      },
      error: {
        generic: "Une erreur est survenue lors de la recherche. Veuillez réessayer.",
        navigation: "Échec de la navigation vers le résultat sélectionné. Veuillez réessayer."
      },
      header: {
        showingResults: "Affichage de {total} résultats pour {intentText} {entity}",
        noResults: "Aucun résultat trouvé pour \"{searchTerm}\"",
        peopleMatching: "personnes correspondant à",
        locationsFor: "lieux pour",
        contactsFor: "contacts pour"
      }
    },
    dashboard: {
      noAccountFor: "Aucun compte {platform}",
      aria: { collapse: "Réduire le menu", expand: "Étendre le menu" },
      contactCard: { title: "Contacter" },
      error: {
        title: "Une erreur est survenue",
        suggestion: "Veuillez vérifier votre connexion Internet et réessayer. Si le problème persiste, le service est peut-être temporairement indisponible.",
        retry: "Réessayer",
        invalidStructure: "Aucun ID de structure valide n'a été fourni. Impossible de charger les données.",
        fetchingData: "Une erreur est survenue lors de la récupération des données de la structure."
      },
      bossView: {
        biography: "Biographie",
        noContactForPlatform: "Aucun compte {platform} disponible"
      },
      embassiesAndConsulates: "Ambassades et Consulats"
    },
    embassy: {
      cameroonEmbassiesAbroad: "Ambassades du Cameroun à l'Étranger",
      foreignEmbassiesInCameroon: "Ambassades Étrangères au Cameroun",
      searchPlaceholder: "Rechercher par pays ou nom d'ambassade...",
      noEmbassiesFoundTitle: "Aucune Ambassade Trouvée",
      searchagain: "Réinitialiser la Recherche",
      viewdetails: "Plus de détails",
      subtitle: "Trouver les Missions Diplomatiques et leurs Coordonnées",
      noEmbassiesFoundMessage: "Les informations sur les ambassades pour cette catégorie sont en cours de mise à jour. Veuillez revenir plus tard.",
      embassyOf: "Ambassade du {country}",
      ambassador: "Ambassadeur",
      services: "Services",
      biography: "Biographie",
      connectAndFollow: "Connectez-vous et suivez",
      noServicesTitle: "Services Bientôt Disponibles",
      noServicesDescription: "Nous compilons actuellement la liste des services offerts par cette ambassade.",
      noServicesNote: "Veuillez revenir bientôt pour des mises à jour.",
      error: {
        invalidEmbassy: "Aucune ambassade valide n'a été spécifiée. Impossible de charger les données.",
        embassyNotFound: "L'ambassade demandée n'a pas pu être trouvée dans notre annuaire.",
        fetchingData: "Une erreur est survenue lors de la récupération des détails de l'ambassade. Veuillez réessayer."
      }
    },
    seeAllResults: "Voir tous les résultats pour",
    biography: "Biographie",
    searching: "Recherche en cours...",
    missionNumber: "Mission {number}",
    serviceNumber: "Service {number}",
    noEmailAddress: "Aucune Adresse Email",
    optional: "Facultatif",
    submiting: "Envoi en cours...",
    no_results_title: "Aucun Résultat Trouvé",
    no_results_message: "Nous n'avons trouvé aucune correspondance pour votre recherche.",
    page_indicator: "Page {current} sur {total}",
    search_placeholder: "Rechercher...",
    error: {
      title: "Une erreur est survenue",
      suggestion: "Veuillez vérifier votre connexion Internet et réessayer. Si le problème persiste, le service est peut-être temporairement indisponible.",
      retry: "Réessayer",
      invalidStructure: "Aucun ID de structure valide n'a été fourni. Impossible de charger les données.",
      fetchingData: "Une erreur est survenue lors de la récupération des données.",
      networkError: "Erreur réseau. Veuillez vérifier votre connexion et réessayer.",
      serverError: "Le serveur a rencontré une erreur. Veuillez réessayer plus tard.",
      submitFailed: "Échec de l'envoi de votre demande. Veuillez réessayer.",
      validationFailed: "Veuillez corriger les erreurs dans le formulaire avant de soumettre.",
    },
    validation: {
      nameRequired: "Le nom complet est requis",
      emailRequired: "L'adresse email est requise",
      emailInvalid: "Veuillez entrer une adresse email valide",
      phoneRequired: "Le numéro de téléphone est requis",
      phoneInvalid: "Veuillez entrer un numéro de téléphone valide",
      descriptionRequired: "La description est requise",
      captchaRequired: "Veuillez compléter la vérification CAPTCHA",
      captchaExpired: "La vérification CAPTCHA a expiré. Veuillez réessayer.",
      captchaFailed: "La vérification CAPTCHA a échoué. Veuillez réessayer.",
    },
    bilingualSearchHint: "Résultats trouvés en {lang}. Vous avez recherché en {searchLang}.",
    langNameEn: "anglais",
    langNameFr: "français",
    switchToResultsLang: "Changer la langue en {lang}",
    chatbot: {
      title: "Assistant Répertoire",
      subtitle: "Posez-moi des questions sur les structures, officiels ou ambassades",
      placeholder: "Posez une question...",
      placeholderExamples: "ex., 'Le MINPOSTEL a-t-il une page Facebook ?'",
      send: "Envoyer",
      typing: "Saisie...",
      thinking: "Réflexion...",
      error: "Désolé, je n'ai pas pu traiter votre demande. Veuillez réessayer.",
      networkError: "Erreur de connexion. Veuillez vérifier votre internet et réessayer.",
      welcome: "Bonjour ! Je suis votre assistant répertoire. Je peux vous aider à trouver des informations sur :",
      welcomeItems: [
        "Les ministères et leurs comptes de réseaux sociaux",
        "Les officiels et leurs coordonnées",
        "Les ambassades et missions diplomatiques",
        "Vérifier si un compte ou numéro est officiel"
      ],
      exampleQuestions: "Essayez de demander :",
      examples: [
        "Le Ministre du MINAT a-t-il un compte Facebook ?",
        "Quel est le Twitter officiel de CAMTEL ?",
        "Coordonnées de l'Ambassade des États-Unis",
        "Ce numéro est-il officiel : +237 6XX XXX XXX ?"
      ],
      minimize: "Réduire",
      close: "Fermer",
      openChat: "Discuter avec l'Assistant",
      clearChat: "Effacer la conversation",
      poweredBy: "Propulsé par CHECK-APP IA"
    },

    // ── Sidebar Menu ──────────────────────────────────────────────────────────
    services: "Services",
    legalConformity: "Conformité Légale",

    // ── Legal Conformity ──────────────────────────────────────────────────────
    physicallyVerified: "Vérification Physique — l'existence physique de cette structure a été confirmée",
    requirementsMet: "exigences satisfaites",
    noConformityData: "Aucune Donnée de Conformité",
    noConformityDesc: "Aucune information de conformité légale n'est disponible pour cette structure.",
    physical: "Physique",
    conformityScore: "Score de Conformité",
    compliant: "Conforme",
    notCompliant: "Non Conforme",
    physicalConformityName: "Conformité Physique",
    physicalConformityDesc: "La structure existe physiquement et a été vérifiée sur place.",

    // ── Registration Portal ───────────────────────────────────────────────────
    registerPortal: "Portail d'Enregistrement des Structures",
    registerTitle: "Créer votre Compte",
    registerSubtitle: "Enregistrez votre structure sur Check-App",
    loginPortal: "Connexion à votre Compte",
    firstName: "Prénom",
    lastName: "Nom de Famille",
    password: "Mot de Passe",
    confirmPassword: "Confirmer le Mot de Passe",
    createAccount: "Créer un Compte",
    alreadyHaveAccount: "Vous avez déjà un compte ?",
    noAccount: "Pas encore de compte ?",
    signIn: "Se Connecter",
    verifyEmailTitle: "Vérifiez votre E-mail",
    verifyEmailMsg: "Nous avons envoyé un lien de vérification à votre adresse e-mail. Cliquez dessus pour activer votre compte.",
    emailVerifiedTitle: "E-mail Vérifié !",
    emailVerifiedMsg: "Votre compte est maintenant actif. Vous pouvez vous connecter.",
    myStructures: "Mes Structures",
    newStructure: "Enregistrer une Nouvelle Structure",
    structureInfo: "Informations sur la Structure",
    contactInfo: "Informations de Contact",
    socialMedia: "Réseaux Sociaux",
    servicesSection: "Services",
    personnelSection: "Personnel Clé",
    delegationsSection: "Délégations Régionales",
    conformitySection: "Conformité Légale",
    documentSection: "Document de Déclaration",
    saveAsDraft: "Enregistrer comme Brouillon",
    submitForReview: "Soumettre pour Révision",
    downloadPdf: "Télécharger le Formulaire PDF",
    downloadDocx: "Télécharger le Formulaire Word",
    uploadSigned: "Téléverser le Document Signé",
    uploadSignedHint: "Imprimez, signez, tamponnez le formulaire et téléversez la version scannée (PDF ou image)",
    pendingReview: "En Attente de Révision",
    approved: "Approuvé",
    rejected: "Rejeté",
    draft: "Brouillon",
    structureName: "Nom de la Structure",
    structureNameEn: "Nom (Anglais)",
    structureNameFr: "Nom (Français)",
    abbreviationEn: "Abréviation (EN)",
    abbreviationFr: "Abréviation (FR)",
    descriptionEn: "Description (Anglais)",
    descriptionFr: "Description (Français)",
    stateOrder: "Ordre d'État / Secteur",
    isHeadOfStructure: "Chef de Structure",
    addService: "Ajouter un Service",
    addPersonnel: "Ajouter du Personnel",
    addDelegation: "Ajouter une Délégation Régionale",
    region: "Région",
    selectConformityCategories: "Sélectionnez vos catégories de conformité",
    tickRequirements: "Cochez les exigences que vous satisfaisez",
    conformityHidden: "Les catégories de conformité seront assignées par l'administration.",
    reviewNotes: "Notes de Révision",
    incompleteWarning: "Veuillez remplir au moins le nom, le téléphone, l'email et l'ordre d'état avant de soumettre.",
    submittedMsg: "Votre structure a été soumise pour révision. Vous serez informé par e-mail de la décision.",
    adminPortal: "Portail Administrateur",
    adminLogin: "Connexion Administrateur",
    enterOtp: "Entrez votre code unique",
    otpSentMsg: "Un code de vérification a été envoyé à votre e-mail et WhatsApp.",
    verifyCode: "Vérifier le Code",
    pendingStructures: "Structures en Attente",
    approveStructure: "Approuver",
    rejectStructure: "Rejeter",
    enterRejectionNotes: "Entrez les notes de rejet pour le demandeur",
  }
};

function getInitialLocale() {
  const savedLocale = localStorage.getItem('user-language');
  if (savedLocale && Object.keys(messages).includes(savedLocale)) {
    return savedLocale;
  }
  const browserLang = navigator.language?.split('-')[0];
  if (browserLang && Object.keys(messages).includes(browserLang)) {
    return browserLang;
  }
  return 'en';
}

const i18n = createI18n({
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages,
  legacy: false,
});

export default i18n;